import React from 'react';

function ModelCard({ model }) {
    return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden max-w-sm">
        <div className="h-64 bg-gray-200 flex overflow hiddenr">
            {model?.photo ? (
                <img
                    src={model.photo}
                    alt={model.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/400x300?text=No+Image';
                    }}
                />
            ) : (
                <div className="w-full h-full flex items-center justify-center">
                    <span className="text-gray-500">Photo</span>
                </div>
            )}
        </div>
        <div className="p-4">
            <h3 className="text-xl font-bold text-gray-800 mb-2">
                {model?.name || 'Model Name'}
            </h3>
            <p className="text-sm text-gray-600 mb-2">
                📍 {model?.location || 'Location'}
            </p>
            <p className="text-gray-700 text-sm mb-3">
                {model?.description || 'Professional model available for bookings'}
            </p>
            <div className="flex justify-between items-center">
                <span className="text-lg font-bold text-green-600">
                    ${model?.price || '50'}/hour
                </span>
                <a
                    href={`https:://wa.me/${model?.whatsapp?.replace(/[^0-9]/g, '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium inline-block text-center"
                >
                    📱 WhatsApp
                </a>
            </div>
        </div>
    </div>
    );
}
export default ModelCard;